/**
 * Created by smahajan on 1/18/2017.
 */
const ReverseMortgagePLF = {
    title: 'Reverse Mortgage Calculator PLF',
    link: '',
    description: '',
    copyright: '2015 LendingTree',
    item: [{
        '62 5': {
            age: 62,
            interest: 5.0,
            factor: 0.524,
        },
        '63 5': {
            age: 63,
            interest: 5.0,
            factor: 0.53,
        },
        '64 5': {
            age: 64,
            interest: 5.0,
            factor: 0.536,
        },
        '65 5': {
            age: 65,
            interest: 5.0,
            factor: 0.542,
        },
        '66 5': {
            age: 66,
            interest: 5.0,
            factor: 0.549,
        },
        '67 5': {
            age: 67,
            interest: 5.0,
            factor: 0.556,
        },
        '68 5': {
            age: 68,
            interest: 5.0,
            factor: 0.562,
        },
        '69 5': {
            age: 69,
            interest: 5.0,
            factor: 0.569,
        },
        '70 5': {
            age: 70,
            interest: 5.0,
            factor: 0.576,
        },
        '71 5': {
            age: 71,
            interest: 5.0,
            factor: 0.583,
        },
        '72 5': {
            age: 72,
            interest: 5.0,
            factor: 0.591,
        },
        '73 5': {
            age: 73,
            interest: 5.0,
            factor: 0.599,
        },
        '74 5': {
            age: 74,
            interest: 5.0,
            factor: 0.606,
        },
        '75 5': {
            age: 75,
            interest: 5.0,
            factor: 0.614,
        },
        '76 5': {
            age: 76,
            interest: 5.0,
            factor: 0.622,
        },
        '77 5': {
            age: 77,
            interest: 5.0,
            factor: 0.631,
        },
        '78 5': {
            age: 78,
            interest: 5.0,
            factor: 0.64,
        },
        '79 5': {
            age: 79,
            interest: 5.0,
            factor: 0.648,
        },
        '80 5': {
            age: 80,
            interest: 5.0,
            factor: 0.657,
        },
        '81 5': {
            age: 81,
            interest: 5.0,
            factor: 0.665,
        },
        '82 5': {
            age: 82,
            interest: 5.0,
            factor: 0.674,
        },
        '83 5': {
            age: 83,
            interest: 5.0,
            factor: 0.682,
        },
        '84 5': {
            age: 84,
            interest: 5.0,
            factor: 0.69,
        },
        '85 5': {
            age: 85,
            interest: 5.0,
            factor: 0.699,
        },
        '86 5': {
            age: 86,
            interest: 5.0,
            factor: 0.709,
        },
        '87 5': {
            age: 87,
            interest: 5.0,
            factor: 0.719,
        },
        '88 5': {
            age: 88,
            interest: 5.0,
            factor: 0.729,
        },
        '89 5': {
            age: 89,
            interest: 5.0,
            factor: 0.739,
        },
        '90 5': {
            age: 90,
            interest: 5.0,
            factor: 0.75,
        },
        '91 5': {
            age: 91,
            interest: 5.0,
            factor: 0.75,
        },
        '92 5': {
            age: 92,
            interest: 5.0,
            factor: 0.75,
        },
        '93 5': {
            age: 93,
            interest: 5.0,
            factor: 0.75,
        },
        '94 5': {
            age: 94,
            interest: 5.0,
            factor: 0.75,
        },
        '95 5': {
            age: 95,
            interest: 5.0,
            factor: 0.75,
        },
        '96 5': {
            age: 96,
            interest: 5.0,
            factor: 0.75,
        },
        '97 5': {
            age: 97,
            interest: 5.0,
            factor: 0.75,
        },
        '98 5': {
            age: 98,
            interest: 5.0,
            factor: 0.75,
        },
        '99 5': {
            age: 99,
            interest: 5.0,
            factor: 0.75,
        },
        '100 5': {
            age: 100,
            interest: 5.0,
            factor: 0.75,
        },
        '101 5': {
            age: 101,
            interest: 5.0,
            factor: 0.75,
        },
        '18 4': {
            age: 18,
            interest: 4.0,
            factor: 0.246,
        },
        '19 4': {
            age: 19,
            interest: 4.0,
            factor: 0.249,
        },
        '20 4': {
            age: 20,
            interest: 4.0,
            factor: 0.253,
        },
        '21 4': {
            age: 21,
            interest: 4.0,
            factor: 0.256,
        },
        '22 4': {
            age: 22,
            interest: 4.0,
            factor: 0.26,
        },
        '23 4': {
            age: 23,
            interest: 4.0,
            factor: 0.264,
        },
        '24 4': {
            age: 24,
            interest: 4.0,
            factor: 0.268,
        },
        '25 4': {
            age: 25,
            interest: 4.0,
            factor: 0.272,
        },
        '26 4': {
            age: 26,
            interest: 4.0,
            factor: 0.276,
        },
        '27 4': {
            age: 27,
            interest: 4.0,
            factor: 0.28,
        },
        '28 4': {
            age: 28,
            interest: 4.0,
            factor: 0.284,
        },
        '29 4': {
            age: 29,
            interest: 4.0,
            factor: 0.288,
        },
        '30 4': {
            age: 30,
            interest: 4.0,
            factor: 0.292,
        },
        '31 4': {
            age: 31,
            interest: 4.0,
            factor: 0.296,
        },
        '32 4': {
            age: 32,
            interest: 4.0,
            factor: 0.3,
        },
        '33 4': {
            age: 33,
            interest: 4.0,
            factor: 0.305,
        },
        '34 4': {
            age: 34,
            interest: 4.0,
            factor: 0.309,
        },
        '35 4': {
            age: 35,
            interest: 4.0,
            factor: 0.314,
        },
        '36 4': {
            age: 36,
            interest: 4.0,
            factor: 0.318,
        },
        '37 4': {
            age: 37,
            interest: 4.0,
            factor: 0.323,
        },
        '38 4': {
            age: 38,
            interest: 4.0,
            factor: 0.328,
        },
        '39 4': {
            age: 39,
            interest: 4.0,
            factor: 0.332,
        },
        '40 4': {
            age: 4.00,
            interest: 4.0,
            factor: 0.337,
        },
        '41 4': {
            age: 4.01,
            interest: 4.0,
            factor: 0.342,
        },
        '42 4': {
            age: 4.02,
            interest: 4.0,
            factor: 0.347,
        },
        '43 4': {
            age: 4.03,
            interest: 4.0,
            factor: 0.352,
        },
        '44 4': {
            age: 4.04,
            interest: 4.0,
            factor: 0.357,
        },
        '45 4': {
            age: 4.05,
            interest: 4.0,
            factor: 0.362,
        },
        '46 4': {
            age: 4.06,
            interest: 4.0,
            factor: 0.368,
        },
        '47 4': {
            age: 4.07,
            interest: 4.0,
            factor: 0.373,
        },
        '48 4': {
            age: 4.08,
            interest: 4.0,
            factor: 0.378,
        },
        '49 4': {
            age: 4.09,
            interest: 4.0,
            factor: 0.384,
        },
        '50 4': {
            age: 50,
            interest: 4.0,
            factor: 0.389,
        },
        '51 4': {
            age: 51,
            interest: 4.0,
            factor: 0.395,
        },
        '52 4': {
            age: 52,
            interest: 4.0,
            factor: 0.401,
        },
        '53 4': {
            age: 53,
            interest: 4.0,
            factor: 0.407,
        },
        '54 4': {
            age: 54,
            interest: 4.0,
            factor: 0.413,
        },
        '55 4': {
            age: 55,
            interest: 4.0,
            factor: 0.419,
        },
        '56 4': {
            age: 56,
            interest: 4.0,
            factor: 0.425,
        },
        '57 4': {
            age: 57,
            interest: 4.0,
            factor: 0.431,
        },
        '58 4': {
            age: 58,
            interest: 4.0,
            factor: 0.437,
        },
        '59 4': {
            age: 59,
            interest: 4.0,
            factor: 0.443,
        },
        '60 4': {
            age: 60,
            interest: 4.0,
            factor: 0.45,
        },
        '61 4': {
            age: 61,
            interest: 4.0,
            factor: 0.456,
        },
        '62 4': {
            age: 62,
            interest: 4.0,
            factor: 0.47,
        },
        '63 4': {
            age: 63,
            interest: 4.0,
            factor: 0.477,
        },
        '64 4': {
            age: 64,
            interest: 4.0,
            factor: 0.483,
        },
        '65 4': {
            age: 65,
            interest: 4.0,
            factor: 0.49,
        },
        '66 4': {
            age: 66,
            interest: 4.0,
            factor: 0.497,
        },
        '67 4': {
            age: 67,
            interest: 4.0,
            factor: 0.504,
        },
        '68 4': {
            age: 68,
            interest: 4.0,
            factor: 0.511,
        },
        '69 4': {
            age: 69,
            interest: 4.0,
            factor: 0.518,
        },
        '70 4': {
            age: 70,
            interest: 4.0,
            factor: 0.522,
        },
        '71 4': {
            age: 71,
            interest: 4.0,
            factor: 0.522,
        },
        '72 4': {
            age: 72,
            interest: 4.0,
            factor: 0.524,
        },
        '73 4': {
            age: 73,
            interest: 4.0,
            factor: 0.532,
        },
        '74 4': {
            age: 74,
            interest: 4.0,
            factor: 0.539,
        },
        '75 4': {
            age: 75,
            interest: 4.0,
            factor: 0.547,
        },
        '76 4': {
            age: 76,
            interest: 4.0,
            factor: 0.553,
        },
        '77 4': {
            age: 77,
            interest: 4.0,
            factor: 0.562,
        },
        '78 4': {
            age: 78,
            interest: 4.0,
            factor: 0.571,
        },
        '79 4': {
            age: 79,
            interest: 4.0,
            factor: 0.576,
        },
        '80 4': {
            age: 80,
            interest: 4.0,
            factor: 0.585,
        },
        '81 4': {
            age: 81,
            interest: 4.0,
            factor: 0.595,
        },
        '82 4': {
            age: 82,
            interest: 4.0,
            factor: 0.605,
        },
        '83 4': {
            age: 83,
            interest: 4.0,
            factor: 0.615,
        },
        '84 4': {
            age: 84,
            interest: 4.0,
            factor: 0.625,
        },
        '85 4': {
            age: 85,
            interest: 4.0,
            factor: 0.636,
        },
        '86 4': {
            age: 86,
            interest: 4.0,
            factor: 0.647,
        },
        '87 4': {
            age: 87,
            interest: 4.0,
            factor: 0.658,
        },
        '88 4': {
            age: 88,
            interest: 4.0,
            factor: 0.667,
        },
        '89 4': {
            age: 89,
            interest: 4.0,
            factor: 0.679,
        },
        '90 4': {
            age: 90,
            interest: 4.0,
            factor: 0.691,
        },
        '91 4': {
            age: 91,
            interest: 4.0,
            factor: 0.703,
        },
        '92 4': {
            age: 92,
            interest: 4.0,
            factor: 0.715,
        },
        '93 4': {
            age: 93,
            interest: 4.0,
            factor: 0.728,
        },
        '94 4': {
            age: 94,
            interest: 4.0,
            factor: 0.741,
        },
        '95 4': {
            age: 95,
            interest: 4.0,
            factor: 0.75,
        },
        '96 4': {
            age: 96,
            interest: 4.0,
            factor: 0.75,
        },
        '97 4': {
            age: 97,
            interest: 4.0,
            factor: 0.75,
        },
        '98 4': {
            age: 98,
            interest: 4.0,
            factor: 0.75,
        },
        '99 4': {
            age: 99,
            interest: 4.0,
            factor: 0.75,
        },
    }],
};
export default ReverseMortgagePLF;
